<template>
	<Teleport to="body">
		<div class="fixed inset-0 z-[100] flex flex-col bg-black" role="dialog" aria-modal="true" aria-label="Meet In His Hands video">
			<div class="flex flex-none justify-end px-1.5" :style="{ paddingTop: 'var(--safe-t)' }">
				<button type="button" class="icon-btn text-white" aria-label="Close video" @click="$emit('close')"><Icon name="close" /></button>
			</div>
			<div class="flex min-h-0 flex-1 items-center">
				<!-- The website's intro video (front/src/components/layout/intro-video.vue); the player loads only now. -->
				<iframe :src="src" class="aspect-video w-full" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="In His Hands video" />
			</div>
			<div class="flex-none" :style="{ height: 'var(--safe-b)' }" />
		</div>
	</Teleport>
</template>

<script>
import Icon from './Icon.vue'

export default {
	components: { Icon },
	emits: ['close'],
	data() {
		return {
			src: 'https://player.vimeo.com/video/1026264453?title=0&byline=0&portrait=0&badge=0&autopause=0&autoplay=1&playsinline=1',
		}
	},
	mounted() {
		this.onKey = (event) => event.key === 'Escape' && this.$emit('close')
		window.addEventListener('keydown', this.onKey)
		document.documentElement.classList.add('sheet-open')
	},
	beforeUnmount() {
		window.removeEventListener('keydown', this.onKey)
		document.documentElement.classList.remove('sheet-open')
	},
}
</script>
